import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
export default function MoneyBagZero({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="money-bag-dollar 1">
        <path
          id="Vector"
          d="M13.6479 16.5H34.6479"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M31.26 10.0718L34.136 4.31984C34.2765 4.03831 34.325 3.71972 34.2745 3.40916C34.224 3.09859 34.0771 2.81177 33.8546 2.58928C33.6321 2.36679 33.3453 2.2199 33.0347 2.16939C32.7241 2.11888 32.4055 2.16732 32.124 2.30784L28.324 4.20384C27.9971 4.36705 27.6218 4.40529 27.2686 4.31139C26.9155 4.21748 26.6087 3.99789 26.406 3.69384L25.4 2.16784C25.263 1.9624 25.0775 1.79396 24.8597 1.67746C24.642 1.56096 24.3989 1.5 24.152 1.5C23.9051 1.5 23.662 1.56096 23.4443 1.67746C23.2266 1.79396 23.041 1.9624 22.904 2.16784L21.886 3.69384C21.6836 3.99823 21.3769 4.2181 21.0236 4.31203C20.6703 4.40597 20.2949 4.36749 19.968 4.20384L16.174 2.30784C15.8924 2.16797 15.574 2.12002 15.2637 2.17072C14.9534 2.22142 14.6668 2.36824 14.4444 2.59046C14.2219 2.81268 14.0748 3.09911 14.0238 3.40938C13.9728 3.71964 14.0204 4.03809 14.16 4.31984L16.98 9.95984"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M14.474 21L8.95403 27.4C7.60324 29.1559 6.77106 31.2549 6.55171 33.4593C6.33237 35.6638 6.73462 37.8856 7.71292 39.8732C8.69122 41.8608 10.2065 43.5348 12.0871 44.7057C13.9678 45.8765 16.1387 46.4974 18.354 46.498H29.934C32.1494 46.4974 34.3203 45.8765 36.2009 44.7057C38.0816 43.5348 39.5968 41.8608 40.5751 39.8732C41.5534 37.8856 41.9557 35.6638 41.7363 33.4593C41.517 31.2549 40.6848 29.1559 39.334 27.4L33.814 21"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="0"
          d="M24.0001 39.5998C20.5184 39.5998 18.6001 36.6141 18.6001 31.1998C18.6001 25.7855 20.5184 22.7998 24.0001 22.7998C27.4707 22.7998 29.4001 25.7855 29.4001 31.1998C29.4001 36.6141 27.4707 39.5998 24.0001 39.5998ZM20.5405 31.1998C20.5405 31.8348 20.5738 32.4253 20.6182 32.9712L27.0716 27.5568C26.5504 25.5627 25.5081 24.5377 24.0001 24.5377C21.7381 24.5377 20.5405 26.8327 20.5405 31.1998ZM24.0001 37.8619C26.2621 37.8619 27.4486 35.5558 27.4486 31.1998C27.4486 30.5537 27.4264 29.9632 27.3709 29.4062L20.9397 34.8651C21.4609 36.8369 22.4921 37.8619 24.0001 37.8619Z"
          fill={fillSecondary}
        />
      </g>
    </svg>
  );
}
